import React from 'react';

export const RefreshArrow = (props) => (
  <svg
    {...props}
    color="#5B2980"
    stroke="currentColor"
    fill={props.fill || '#5B2980'}
    strokeWidth="0"
    viewBox="0 0 512 512"
    width="22"
    height="22"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fill="none"
      strokeLinecap="round"
      strokeMiterlimit="10"
      strokeWidth="28"
      d="M288 193s12.18-6-32-6a80 80 0 1080 80"
    />
    <path fill="none" strokeLinecap="round" strokeLinejoin="round" strokeWidth="28" d="M256 149l40 40-40 40" />
    <path
      fill="none"
      strokeMiterlimit="10"
      strokeWidth="32"
      d="M256 64C150 64 64 150 64 256s86 192 192 192 192-86 192-192S362 64 256 64z"
    />
  </svg>
);

export default RefreshArrow;
